export const card = '/card';
export const ssoCodeExchange = '/exchange_code';
